<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header" *ngIf="template">
    <div class="card-title">
      <h3 class="card-label" translate>
        {{ getTitle() }}
        <span class="card-label">{{ templateName ? templateName : '' }} Agreement Template</span>
      </h3>
    </div>
  </div>

  <div class="card-body" *ngIf="template">
    <kt-alert
      *ngIf="hasFormErrors"
      type="warn"
      [duration]="30000"
      [showCloseButton]="true"
      (closeAl)="onAlertClose()"
    >
      <span translate="GLOBAL.FORM_ERROR"></span>
    </kt-alert>

    <form [formGroup]="form" class="form form-group mb-0">
      <div class="mb-2">
        <div class="mb-2">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" required />
          </mat-form-field>
        </div>
      </div>

      <div class="mb-2">
        <div class="mb-2">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" required />
          </mat-form-field>
        </div>
      </div>

      <mat-form-field appearance="fill" class="mat-form-field-fluid">
        <mat-label>Agreement Type</mat-label>
        <mat-select formControlName="templateType">
          <mat-option *ngFor="let type of templateTypes" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-field-fluid">
        <mat-label>Offices</mat-label>
        <mat-select formControlName="offices" multiple>
          <mat-option *ngFor="let office of offices" [value]="office.id">
            {{ office.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="!isEdit" class="file-input mb-6" (click)="fileInput.click()">
        <div>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.FILE' | translate }}</mat-label>
            <input matInput required readonly type="text" formControlName="fileName" />
            <input
              #fileInput
              required
              hidden
              type="file"
              accept=".pdf"
              (change)="changeFile($event)"
            />
            <mat-hint>Accepted file type .pdf</mat-hint>
          </mat-form-field>
        </div>
        <span
          matTooltip="{{ 'TABLE.ATTACH' | translate }} File"
          class="btn btn-icon btn-light-primary btn-hover-primary"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/attachment.svg"
            class="svg-icon svg-icon-lg svg-icon-primary"
          ></span>
        </span>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <mat-spinner *ngIf="viewLoading" [diameter]="20" mode="indeterminate"></mat-spinner>

      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          mat-dialog-close
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="viewLoading"
          matTooltip="Next Step"
        >
          <span>Next Step</span>
        </button>
      </div>
    </div>
  </div>
</div>
